<template>
  <div class="whole">
    <el-container class="whole-left">
      <el-header class="whole-left-top">
        <div style="width:30%">
          <img src="@/assets/images/wpsp/Customer-view/资产汇总.png" />
          <span>金融资产(元)</span>
        </div>
        <div class="money"
             style="width:60%">
          <div>
            <p>¥{{ total.inBankAll | addMoneyFilter }}</p>
            <p>行内</p>
          </div>
          <div>
            <p>¥{{ total.outBankAll | addMoneyFilter }}</p>
            <p>行外</p>
          </div>
          <div>
            <p>¥{{ total.sumMoney | addMoneyFilter }}</p>
            <p>总计</p>
          </div>
        </div>
      </el-header>
      <el-container style="height:170px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          固
          <br />收 <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">理财</el-col>
              <el-col :span="8">¥{{ within.finance | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.finance | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.finance"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">大额存单</el-col>
              <el-col :span="8">¥{{ within.largeDeposit | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.largeDeposit | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.largeDeposit"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">债券基金</el-col>
              <el-col :span="8">¥{{ within.bondFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.bondFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.bondFund"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">定期存款</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.deposit | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.deposit"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">债券型基金</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.bond | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.bond"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">可转债</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.convertibleBond | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.convertibleBond"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">国债逆回购</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.reRepurchaseNationalDebt | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.reRepurchaseNationalDebt"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">信托计划</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.trustScheme | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.trustScheme"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">其他固收资产</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.otherFixedIncomeAssets | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.otherFixedIncomeAssets"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-aside width="150px"
                  class="content-right">
          <span v-if="editShow" class="text">¥{{ (total.inFixIncomeMoney + total.outFixIncomeMoney) | addMoneyFilter }}</span>
          <el-input maxlength="13"
                    v-else
                    v-model="sumTotal.fixIncomeMoney"
                    placeholder="请输入内容"
                    style="width:150px;"
                    class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          货
          <br />币 <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">现金及活存</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.cash | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.cash"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">货币基金</el-col>
              <el-col :span="8">¥{{ within.currencyFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.currencyFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.currencyFund"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">其他货币资产</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.otherMonetaryAssets | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.otherMonetaryAssets"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-aside width="150px"
                  class="content-right">
          <span v-if="editShow" class="text">¥{{ (total.inCurrencyMoney + total.outCurrencyMoney) | addMoneyFilter }}</span>
          <el-input maxlength="13"
                    v-else
                    placeholder="请输入内容"
                    style="width:150px; "
                    v-model="sumTotal.currencyMoney"
                    class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          权
          <br />益 <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">指数/混合/股票基金</el-col>
              <el-col :span="8">¥{{ within.mixFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.mixFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.mixFund"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">股票</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.shares | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.shares"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">其他权益资产</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.otherEquityAssets | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.otherEquityAssets"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-aside width="150px"
                  class="content-right">
          <span v-if="editShow" class="text">¥{{ (total.inEquityMoney + total.outEquityMoney) | addMoneyFilter }}</span>
          <el-input maxlength="13"
                    v-else
                    placeholder="请输入内容"
                    style="width:150px; "
                    v-model="sumTotal.equityMoney"
                    class="external"></el-input>
        </el-aside>
      </el-container>
      <el-container style="height:110px;border: 1px solid rgba(220, 223, 230, 1);border-top: 0px">
        <el-aside width="45px"
                  class="content-left">
          商
          <br />品 <br />类
        </el-aside>
        <el-main class="content-Middle">
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">纸黄金</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.paperGold | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.paperGold"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table background">
            <el-row class="table-row">
              <el-col :span="8">黄金ETF联接基</el-col>
              <el-col :span="8">¥{{ within.goldEtfFeederFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.goldEtfFeederFund | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.goldEtfFeederFund"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table">
            <el-row class="table-row">
              <el-col :span="8">其他商品资产</el-col>
              <el-col :span="8">-</el-col>
              <el-col :span="8"
                      v-if="editShow">¥{{ external.otherCommodityAssets | addMoneyFilter }}</el-col>
              <el-col :span="8"
                      v-else>
                <el-input maxlength="13"
                          v-model="external.otherCommodityAssets"
                          placeholder="请输入内容"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-main>
        <el-aside width="150px"
                  class="content-right">
          <span v-if="editShow" class="text">¥{{ (total.inCommodityMoney + total.outCommodityMoney) | addMoneyFilter }}</span>
          <el-input maxlength="13"
                    v-else
                    placeholder="请输入内容"
                    style="width:150px; "
                    v-model="sumTotal.commodityMoney"
                    class="external"></el-input>
        </el-aside>
      </el-container>
    </el-container>
    <div class="whole-right">
      <el-container class="top">
        <el-header class="first-line">
          <div>
            <img src="@/assets/images/wpsp/Customer-view/资产汇总.png" />
            <span>实物资产(元)</span>
          </div>
          <div>¥{{ total.physicalAssetsMoney | addMoneyFilter }}</div>
        </el-header>
        <el-main class="content">
          <div class="table">
            <span>房产</span>
            <span class="value"
                  v-if="editShow">¥{{ external.houseProperty | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.houseProperty"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>车辆</span>
            <span class="value"
                  v-if="editShow">¥{{ external.vehicle | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.vehicle"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>收藏品</span>
            <span class="value"
                  v-if="editShow">¥{{ external.collection | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.collection"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>其他实物资产</span>
            <span class="value"
                  v-if="editShow">¥{{ external.otherPhysicalAssets | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.otherPhysicalAssets"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
        </el-main>
      </el-container>
      <el-container class="bottom">
        <el-header class="first-line">
          <div>
            <img src="@/assets/images/wpsp/Customer-view/资产负债表-selected.png" />
            <span>负债(元)</span>
          </div>
          <div>¥{{ total.liabilitiesMoney | addMoneyFilter }}</div>
        </el-header>
        <el-main class="content">
          <div class="table">
            <span>未还房贷</span>
            <span class="value"
                  v-if="editShow">¥{{ external.notMortgage | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.notMortgage"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>未还车贷</span>
            <span class="value"
                  v-if="editShow">¥{{ external.notCarLoans | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.notCarLoans"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>分期贷款消费</span>
            <span class="value"
                  v-if="editShow">¥{{ external.installmentLoan | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.installmentLoan"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table background">
            <span>信用卡透支余额</span>
            <span class="value"
                  v-if="editShow">¥{{ external.creditcardOverdraftBalance | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.creditcardOverdraftBalance"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
          <div class="table">
            <span>其他负债</span>
            <span class="value"
                  v-if="editShow">¥{{ external.otherLiabilities | addMoneyFilter }}</span>
            <el-input maxlength="13"
                      v-else
                      v-model="external.otherLiabilities"
                      placeholder="请输入内容"
                      style="width:150px; "></el-input>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cis: JSON.parse(sessionStorage.getItem('customer')).cis,
      editShow: true,
      // 行内行外总计信息
      total: {},
      // 行内行外总计之和
      sumTotal: {
        fixIncomeMoney: '',
        currencyMoney: '',
        equityMoney: '',
        commodityMoney: '',
      },

      // 修改前的总和
      beforeTotal: {
        fixIncomeMoney: '',
        currencyMoney: '',
        equityMoney: '',
        commodityMoney: '',
      },
      // 行内信息
      within: {},
      // 行外信息
      external: {},
      // 固收类行外其他备份
      otherFixedIncomeAssets: '',
      // 货币类行外其他备份
      otherMonetaryAssets: '',
      // 权益类行外其他备份
      otherEquityAssets: '',
      // 商品类行外其他备份
      otherCommodityAssets: '',
    };
  },
  watch: {
    // 修改固守总额
    'sumTotal.fixIncomeMoney': {
      handler() {
        this.external.otherFixedIncomeAssets = this.otherFixedIncomeAssets
          + (this.sumTotal.fixIncomeMoney - this.beforeTotal.fixIncomeMoney);
      },
    },
    // 修改货币总额
    'sumTotal.currencyMoney': {
      handler() {
        this.external.otherMonetaryAssets = this.otherMonetaryAssets
          + (this.sumTotal.currencyMoney - this.beforeTotal.currencyMoney);
      },
    },
    // 修改权益总额
    'sumTotal.equityMoney': {
      handler() {
        this.external.otherEquityAssets = this.otherEquityAssets
          + (this.sumTotal.equityMoney - this.beforeTotal.equityMoney);
      },
    },
    // 修改商品总额
    'sumTotal.commodityMoney': {
      handler() {
        this.external.otherCommodityAssets = this.otherCommodityAssets
          + (this.sumTotal.commodityMoney - this.beforeTotal.commodityMoney);
      },
    },
  },
  props: ['custRelationship'],
  mounted() {
    this.getAssetLiability();
  },
  methods: {
    edit(bool) {
      this.editShow = bool;
    },
    // 资产负债信息
    getAssetLiability() {
      const parames = {
        data: {
          cis: this.cis,
          custRelationship: this.custRelationship,
        },
      };
      this.$_post(this.$API.getAssetLiability, parames).then((res) => {
        this.total = res.data.custFinanceSum;
        this.sumTotal.fixIncomeMoney = this.total.inFixIncomeMoney + this.total.outFixIncomeMoney;
        this.sumTotal.currencyMoney = this.total.inCurrencyMoney + this.total.outCurrencyMoney;
        this.sumTotal.equityMoney = this.total.inEquityMoney + this.total.outEquityMoney;
        this.sumTotal.commodityMoney = this.total.inCommodityMoney + this.total.outCommodityMoney;
        this.beforeTotal.fixIncomeMoney = this.total.inFixIncomeMoney + this.total.outFixIncomeMoney;
        this.beforeTotal.currencyMoney = this.total.inCurrencyMoney + this.total.outCurrencyMoney;
        this.beforeTotal.equityMoney = this.total.inEquityMoney + this.total.outEquityMoney;
        this.beforeTotal.commodityMoney = this.total.inCommodityMoney + this.total.outCommodityMoney;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < res.data.custFinanceList.length; i++) {
          if (res.data.custFinanceList[i].isBank === '0') {
            this.within = res.data.custFinanceList[i];
          } else if (res.data.custFinanceList[i].isBank === '1') {
            this.external = res.data.custFinanceList[i];
            this.otherFixedIncomeAssets = res.data.custFinanceList[i].otherFixedIncomeAssets;
            this.otherMonetaryAssets = res.data.custFinanceList[i].otherMonetaryAssets;
            this.otherEquityAssets = res.data.custFinanceList[i].otherEquityAssets;
            this.otherCommodityAssets = res.data.custFinanceList[i].otherCommodityAssets;
          }
        }
      });
    },
    // 修改方法
    modify() {
      if (this.sumTotal.fixIncomeMoney < this.total.inFixIncomeMoney) {
        this.$message.error(
          `请输入大于等于固收类中行内资产${this.total.inFixIncomeMoney}的值`,
        );
        this.sumTotal.fixIncomeMoney = this.beforeTotal.fixIncomeMoney;
        this.$emit('ModificationFailed', false);
        this.editShow = false;
        return;
      }
      if (this.sumTotal.currencyMoney < this.total.inCurrencyMoney) {
        this.$message.error(
          `请输入大于等于货币类中行内资产${this.total.inCurrencyMoney}的值`,
        );
        this.sumTotal.currencyMoney = this.beforeTotal.currencyMoney;
        this.$emit('ModificationFailed', false);
        this.editShow = false;
        return;
      }
      if (this.sumTotal.equityMoney < this.total.inEquityMoney) {
        this.$message.error(
          `请输入大于等于权益类中行内资产${this.total.inEquityMoney}的值`,
        );
        this.sumTotal.equityMoney = this.beforeTotal.equityMoney;
        this.$emit('ModificationFailed', false);
        this.editShow = false;
        return;
      }
      if (this.sumTotal.commodityMoney < this.total.inCommodityMoney) {
        this.$message.error(
          `请输入大于等于商品类中行内资产${this.total.inCommodityMoney}的值`,
        );
        this.sumTotal.commodityMoney = this.beforeTotal.commodityMoney;
        this.$emit('ModificationFailed', false);
        this.editShow = false;
        return;
      }
      if (this.sumTotal.fixIncomeMoney < this.beforeTotal.fixIncomeMoney) {
        if (
          this.beforeTotal.fixIncomeMoney - this.sumTotal.fixIncomeMoney
          > this.external.otherFixedIncomeAssets
        ) {
          this.$message.error(
            '固收类行外其他资产资金不足，请手动调整资产类别的金额',
          );
          this.external.otherFixedIncomeAssets = this.otherFixedIncomeAssets;
          this.sumTotal.fixIncomeMoney = this.beforeTotal.fixIncomeMoney;
          this.$emit('ModificationFailed', false);
          this.editShow = false;
          return;
        }
      }
      if (this.sumTotal.currencyMoney < this.beforeTotal.currencyMoney) {
        if (
          this.beforeTotal.currencyMoney - this.sumTotal.currencyMoney
          > this.external.otherMonetaryAssets
        ) {
          this.$message.error(
            '货币类行外其他资产资金不足，请手动调整资产类别的金额',
          );
          this.external.otherMonetaryAssets = this.otherMonetaryAssets;
          this.sumTotal.currencyMoney = this.beforeTotal.currencyMoney;
          this.$emit('ModificationFailed', false);
          this.editShow = false;
          return;
        }
      }
      if (this.sumTotal.equityMoney < this.beforeTotal.equityMoney) {
        if (
          this.beforeTotal.equityMoney - this.sumTotal.equityMoney
          > this.external.otherEquityAssets
        ) {
          this.$message.error(
            '权益类行外其他资产资金不足，请手动调整资产类别的金额',
          );
          this.external.otherEquityAssets = this.otherEquityAssets;
          this.sumTotal.equityMoney = this.beforeTotal.equityMoney;
          this.$emit('ModificationFailed', false);
          this.editShow = false;
          return;
        }
      }
      if (this.sumTotal.commodityMoney < this.beforeTotal.commodityMoney) {
        if (
          this.beforeTotal.commodityMoney - this.sumTotal.commodityMoney
          > this.external.otherCommodityAssets
        ) {
          this.$message.error(
            '商品类行外其他资产资金不足，请手动调整资产类别的金额',
          );
          this.external.otherCommodityAssets = this.otherCommodityAssets;
          this.sumTotal.commodityMoney = this.beforeTotal.commodityMoney;
          this.$emit('ModificationFailed', false);
          this.editShow = false;
          return;
        }
      }
      const parames = {
        data: {
          cis: this.cis,
          self: this.custRelationship,
          custFinanceInfo: this.external,
          fixIncomeDifferenceValue:
            this.sumTotal.fixIncomeMoney - this.beforeTotal.fixIncomeMoney,
          currencyDifferenceValue:
            this.sumTotal.currencyMoney - this.beforeTotal.currencyMoney,
          equityDifferenceValue:
            this.sumTotal.equityMoney - this.beforeTotal.equityMoney,
          commodityDifferenceValue:
            this.sumTotal.commodityMoney - this.beforeTotal.commodityMoney,
        },
      };
      this.$_post(this.$API.modifyLiabilities, parames).then((res) => {
        console.log(res);
        this.getAssetLiability();
        this.$emit('ModificationFailed', true);
      });
    },
  },
};
</script>
<style lang="scss">
.whole {
  display: flex;
  flex-direction: row;
  .el-input__inner {
    width: 100px;
    height: 25px !important;
    line-height: 25px;
  }
  .whole-left {
    width: 55%;
    .whole-left-top {
      display: flex;
      justify-content: space-between;
      img {
        position: relative;
        top: 3px;
        margin-right: 8px;
      }
      height: 60px;
      border: 1px solid rgba(220, 223, 230, 1);
      background: rgba(241, 247, 255, 1);
      display: flex;
      flex-direction: row;
      align-items: center;
      .money {
        display: flex;
        justify-content: space-between;
        text-align: right;
      }
    }
    .content-left {
      font-size: 14px;
      color: rgba(96, 98, 102, 1);
      border-right: 1px solid rgba(220, 223, 230, 1);
      border-top: 0px;
      background: rgba(245, 247, 250, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content-Middle {
      padding: 0px;
      .background {
        background: rgba(245, 247, 250, 1);
      }
      .table {
        padding: 2px 0px;
        width: 720px;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content: space-around;
        .table-row {
          width: 100%;
          text-align: center;
          height: 30px;
          margin: 0px;
          .el-col {
            height: 30px;
            .el-input {
              text-align: center;
            }
          }
        }
        span {
          font-size: 12px;
          color: rgba(48, 49, 51, 1);
        }
      }
    }
    .content-right {
      color: rgba(48, 49, 51, 1);
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        display: inline-block;
        padding: 0px 15px;
        width: 150px;
        text-align: right;
      }
      .external{
            text-align: right;
      }
    }
  }
  .whole-right {
    margin-left: 2%;
    width: 35.5%;
    .top {
      height: 225px;
      border: 1px solid rgba(220, 223, 230, 1);
      .first-line {
        padding: 0px 30px 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
        }
      }
    }
    .bottom {
      height: 295px;
      border: 1px solid rgba(220, 223, 230, 1);
      margin-top: 40px;
      .first-line {
        padding: 0px 30px 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(241, 247, 255, 1);
        border-bottom: 1px solid rgba(220, 223, 230, 1);
        img {
          position: relative;
          top: 3px;
          margin-right: 10px;
        }
      }
      .content {
        padding: 0px;
        .background {
          background: rgba(245, 247, 250, 1);
        }
        .table {
          height: 30px;
          padding: 4.5px 32px 4.5px 37px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
        }
      }
    }
  }
}
</style>
